module.exports = __webpack_public_path__ + "img/fill_logo.e980d230.png";